import api from './api'
import { noop, merge, messageUtils } from '../utils/commonUtils'
import { show as showSpinner, hide as hideSpinner } from '../utils/spinnerUtils'

const defaultReject = ({ message }) => messageUtils.alert(message, { type: 'error' })

const serviceBuilder = ({
  method = 'post',
  url,
  params: defaultBody = {},
  headers: defaultHeaders,
  passportAPIServerHost,
  show: buildShow = showSpinner,
  hide: buildHide = hideSpinner,
}) => ({
  params: data = {},
  headers,

  resolve = noop,
  reject = defaultReject,
  complete = noop,

  show = buildShow,
  hide = buildHide,
  ignoreTrim,
} = {}) => {
  const apiCallConfig = {
    headers: merge(defaultHeaders, headers),
    data: merge(defaultBody, data),
    _ignoreTrim: ignoreTrim,
    passportAPIServerHost,
  }

  show()
  return api[method](url, apiCallConfig)
    .then(resolve, reject)
    .finally(() => {
      complete()
      hide()
    })
}

export default serviceBuilder
